import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_BASE from "../config/api";
import BusinessWebsite from "./BusinessWebsite";
import PersonalWebsite from "./PersonalWebsite";
import PoliticalWebsite from "./PoliticalWebsite";

/*
  Both "/:domain" routes used to be registered with different elements
  (BusinessWebsite and PersonalWebsite) — React Router just always matched
  the first one, so a Personal Portfolio domain would render the Business
  template. This component replaces both routes with a single one: it asks
  the backend which kind of site this domain is, then renders the matching
  page. The chosen page component still does its own data fetch afterwards
  (same as before) — this only decides WHICH component to mount.
*/
export default function SiteResolver() {
    const { domain } = useParams();
    const [status, setStatus] = useState("checking"); // checking | business | personal | political | notfound

    useEffect(() => {
        if (!domain) { setStatus("notfound"); return; }
        let cancelled = false;
        setStatus("checking");

        const checkBusiness = fetch(`${API_BASE}/api/get_business_site.php?domain=${encodeURIComponent(domain)}`)
            .then((r) => r.json()).catch(() => null);
        const checkPersonal = fetch(`${API_BASE}/api/get_personal_site.php?domain=${encodeURIComponent(domain)}`)
            .then((r) => r.json()).catch(() => null);
        const checkPolitical = fetch(`${API_BASE}/api/get_political_site.php?domain=${encodeURIComponent(domain)}`)
            .then((r) => r.json()).catch(() => null);

        Promise.all([checkBusiness, checkPersonal, checkPolitical]).then(([biz, per, pol]) => {
            if (cancelled) return;
            const bizOk = !!(biz && biz.success && biz.data);
            const perOk = !!(per && per.success && per.data);
            const polOk = !!(pol && pol.success && pol.data);
            // A domain shouldn't ever match more than one of these, but if it
            // somehow does, prefer business (paid/commercial), then political,
            // then personal.
            if (bizOk) setStatus("business");
            else if (polOk) setStatus("political");
            else if (perOk) setStatus("personal");
            else setStatus("notfound");
        });

        return () => { cancelled = true; };
    }, [domain]);

    if (status === "checking") {
        return (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
                <div className="spinner-border text-primary" role="status" />
            </div>
        );
    }

    if (status === "business") return <BusinessWebsite />;
    if (status === "personal") return <PersonalWebsite />;
    if (status === "political") return <PoliticalWebsite />;

    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", textAlign: "center", padding: 24, fontFamily: "Inter, sans-serif" }}>
            <h2 style={{ fontWeight: 700, marginBottom: 8 }}>Site not found</h2>
            <p style={{ color: "#6b7280" }}>We couldn't find a website at <b>dialnepal.com.np/{domain}</b>.</p>
        </div>
    );
}